import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BroadcastService } from '@services/broadcast-service';
import { CsIconModule } from '@components/icon';
import { ButtonModule } from '@components/button';
import { ReAcquisitionService } from '@services/re-acquisition-service/re-acquisition.service';
import { Router } from '@angular/router';
import { ReAcquisitionHelper } from '../../../helper/re-acquisition-helper/re-acquisition-helper';
import { EventLoggerService } from '@services/event-logger-service';
import { ConnectionService } from '@services/connection-service';

@Component({
  selector: 'app-re-acquisition-user-query-v2',
  imports: [
    CommonModule,
    FormsModule,
    CsIconModule,
    ButtonModule,
  ],
  templateUrl: './re-acquisition-user-query-v2.component.html',
})
export class ReAcquisitionUserQueryV2Component implements OnInit {
  userQuery: string = "";
  invalidUserInputError: string = "";
  isTextareaFocused: boolean = false;
  user: Table.User;

  constructor(
    private readonly broadcast: BroadcastService,
    private readonly reAcquisitionService: ReAcquisitionService,
    private readonly router: Router,
    private readonly reAcquisitionHelper: ReAcquisitionHelper,
    private readonly eventLogger: EventLoggerService,
    private readonly connectionService: ConnectionService,
  ) {}

  ngOnInit(): void {
    this.user = this.connectionService.getActingUser();
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'reacquisition_user_issue_description', type: 'full_screen' }));
  }

  async onContinue(): Promise<void> {
    const userLanguagePreference = this.user?.get('languagePreference');
    const validationReponse = this.reAcquisitionHelper.validateUserQuery(this.userQuery, userLanguagePreference);
    if (!validationReponse.valid) {
      this.invalidUserInputError = validationReponse.error;
      return;
    }
    await this.reAcquisitionService.createReAcquisitionPendingCall(this.userQuery);
    this.router.navigate(['/re-acquisition/waiting-for-call'], { queryParams: { isRebranding: true } });
  }

  handleOnChange(): void {
    if (this.userQuery.length > this.reAcquisitionHelper.MIN_QUERY_LENGTH || !this.userQuery.length) {
      this.invalidUserInputError = '';
    }
  }

  back(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  onTextareaFocus(): void {
    this.isTextareaFocused = true;
  }

  onTextareaBlur(): void {
    this.isTextareaFocused = false;
  }
}
